module.exports = __webpack_public_path__ + "static/media/camera-movie.0c163f55.svg";